import React from 'react';
import PropTypes from 'prop-types';

import { isAndroid } from 'src/core/util/browser';

import Url from 'src/components/url/Url';

import 'src/components/generic-icon/GenericIcon.scss';


function DetailSocialRaw({ data, actions }) {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const target = global.isCordovaContext && !isAndroid() ? '_system' : null;
  const style = {WebkitMaskSize: '100%', maskSise: '100%'};

  
  return (
    <>
      {data.tw && (
        <Url
          className="twitter-icon"
          callback={actions.linkClicked}
          href={data.tw}
          target={target}
          style={style}
        />
      )}
      {data.fb && (
        <Url
          className="facebook-icon"
          callback={actions.linkClicked}
          href={data.fb}
          target={target}
          style={style}
        />
      )}
      {data.ig && (
        <Url
          className="instagram-icon"
          callback={actions.linkClicked}
          href={data.ig}
          target={target}
          style={style}
        />
      )}
      {data.ln && (
        <Url
          className="linkedin-icon"
          callback={actions.linkClicked}
          href={data.ln}
          target={target}
          style={style}
        />
      )}
      {data.yt && (
        <Url
          className="youtube-icon"
          callback={actions.linkClicked}
          href={data.yt}
          target={target}
          style={style}
        />
      )}
      {data.tk && (
        <Url
          className="tiktok-icon"
          callback={actions.linkClicked}
          href={data.tk}
          target={target}
        />
      )}
    </>
  );
}

DetailSocialRaw.propTypes = {
  data: PropTypes.object,
  actions: PropTypes.object.isRequired,
};

export default DetailSocialRaw;
